let loadingRequests = 0
let loadingTimer = 0

function showLoading (hideBackground = false) {
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    loadingRequests = loadingRequests + 1
    clearTimeout(loadingTimer)

    appLoading.classList.remove('in-active')
    appLoading.style.display = 'block'

    if (hideBackground) {
      appLoading.classList.add('hide-background')
    }

    setTimeout(() => {
      appLoading.classList.add('active')
    }, 10)
  }
}

function hideLoading (force = false) {
  if (loadingRequests > 0) {
    loadingRequests = loadingRequests - 1
  }
  clearTimeout(loadingTimer)
  loadingTimer = setTimeout(() => {
    if (loadingRequests <= 0 || force) {
      const appLoading = document.getElementById('loading-bg')
      if (appLoading) {
        appLoading.classList.remove('active')
        appLoading.classList.remove('hide-background')
        appLoading.classList.add('in-active')

        setTimeout(() => {
          appLoading.style.display = 'none'
        }, 10)
      }
    }
  }, 300)
}

export const loading = {
  show: showLoading,
  hide: hideLoading
}
